export const dateFormats = {
  standard: "DD [de] MMMM [de] YYYY",
  simple: "DD/MM/YYYY",
};
